export const IconGoldendGol = () => {
  return (
    <svg
      className="w-full"
      enableBackground="new 0 0 25 25"
      viewBox="0 0 25 25"
      x="0px"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      y="0px"
    >
      <g>
        <path
          d="M12.6,1.1L12.6,1.1c6.4,0,11.5,5.1,11.5,11.5l0,0c0,6.4-5.1,11.5-11.5,11.5
     l0,0C6.3,24.1,1.1,19,1.1,12.6l0,0C1.1,6.3,6.3,1.1,12.6,1.1z"
          fill="#FEF6BD"
        />
        <path
          d="M12.6,1.8L12.6,1.8
     c6,0,10.8,4.8,10.8,10.8l0,0c0,6-4.8,10.8-10.8,10.8l0,0c-6,0-10.8-4.8-10.8-10.8l0,0C1.8,6.7,6.7,1.8,12.6,1.8z"
          fill="none"
          stroke="#FEF6BD"
          strokeWidth="1.4133"
        />
      </g>
      <g>
        <g clipPath="url(#SVGID_00000023239580602880034120000003747079650348554148_)">
          <path
            d="M21.1,4.1h-17v17h17V4.1z"
            fill="#FFFFFF"
            fillOpacity="1.000000e-02"
          />
          <path
            d="M12.6,19.7
       c3.9,0,7.1-3.2,7.1-7.1c0-3.9-3.2-7.1-7.1-7.1s-7.1,3.2-7.1,7.1C5.5,16.5,8.7,19.7,12.6,19.7z"
            fill="none"
            stroke="#BA9C06"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.25"
          />
          <path
            d="M14.8,6.4L12.7,8v1.5
       l2.7,2.2l1.5-0.6l0.9-2.5"
            fill="none"
            stroke="#BA9C06"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.25"
          />
          <path
            d="M10.5,6.4L12.7,8v1.5
       l-2.7,2.2L8.4,11L7.5,8.6"
            fill="none"
            stroke="#BA9C06"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.25"
          />
          <path
            d="M6.3,12L8.4,11
       l1.5,0.6l0.9,3.4l-0.9,1.2H7.2"
            fill="none"
            stroke="#BA9C06"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.25"
          />
          <path
            d="M9.9,18.5v-2.2
       l0.9-1.2h3.7l0.9,1.2v2.2"
            fill="none"
            stroke="#BA9C06"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.25"
          />
          <path
            d="M18.1,16.3h-2.7
       l-0.9-1.2l0.9-3.4l1.5-0.6l2.4,1.2"
            fill="none"
            stroke="#BA9C06"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.25"
          />
        </g>
      </g>
    </svg>
  );
};
